module.exports = __webpack_public_path__ + "static/media/bed.382f77fe.svg";